import { Injectable } from "@angular/core";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { AngularFirestore, AngularFirestoreCollection } from "@angular/fire/compat/firestore";
import * as moment from "moment";
import { BehaviorSubject, of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { AppointmentLog } from "../models/log.model";
import * as utils from '../utils/utility-functions';

@Injectable({
    providedIn: 'root',
})

export class LogService {
    private logs = new BehaviorSubject([]);
    currentLogs = this.logs.asObservable();

    constructor(
        private afAuth: AngularFireAuth,
        private angularFirestore: AngularFirestore
    ) { }

    getAppointmentLogsObservable(id: string) {
        return this.afAuth.authState.pipe(
            switchMap(user => {
                if (user) {
                    return this.angularFirestore.collection<AppointmentLog>('Logs', ref => ref
                        .where('appointment_id', '==', id)
                        .orderBy('created_at', 'asc'))
                        .valueChanges({ idField: 'id' });
                } else {
                    return of(null);
                }
            })
        );
    }

    async getAppointmentLogs(id: string) {
        try {
            let appointments = [];

            const collection: AngularFirestoreCollection = this.angularFirestore.collection('Logs');

            await collection.ref
                .where('appointment_id', '==', id)
                .orderBy('created_at', 'desc')
                .get()
                .then(querySnapshot => {
                    querySnapshot.forEach(doc => {
                        const docData = {
                            id: doc.id,
                            ...doc.data()
                        }
                        appointments.push(docData)
                    });
                }).catch(err => console.log("getAppointmentLogs query 1 error: " + err));

            this.updateLogs(appointments);
            return appointments;
        } catch (error) {
            console.log('getAppointmentLogs(): ' + JSON.stringify(error));
        }
    }

    async createAppointmentLog(appointment_id: string, message: string) {
        try {
            const user = await this.afAuth.currentUser;

            const collection: AngularFirestoreCollection = this.angularFirestore.collection('Logs');

            message += ` by`;
            let newLogObject = {
                appointment_id: appointment_id,
                message: message,
                username: user.email,
                created_at: Number(moment().format('x'))
            }

            await collection.ref
                .add(JSON.parse(JSON.stringify(newLogObject)))
                .catch(err => console.log("createAppointmentLog add 1 error: " + err));

        } catch (error) {
            console.log(error);
        }
    }


    async createCoverageLog(message) {
        try {
            const user = await this.afAuth.currentUser;

            const collection: AngularFirestoreCollection = this.angularFirestore.collection('Logs');

            message += ` by ${user.email}`;
            let newLogObject = {
                message: message
            }

            await collection.ref
                .add(JSON.parse(JSON.stringify(newLogObject)))
                .catch(err => console.log("createCoverageLog add 1 error: " + err));
        } catch (error) {
            console.log(error);
        }
    }

    updateLogs(logsResult: any) {
        let logsArray = [];
        logsResult.forEach(log => {
            const newLog = utils.createAppointmentLog(log);
            logsArray.push(newLog);
        });
        this.logs.next(logsArray);
    }
}